import {Component, Input} from '@angular/core';
import {CommonModule, DatePipe, NgIf} from "@angular/common";
import {OrderSummary} from "../../../models/cart-item";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-order-list-card',
  standalone: true,
    imports: [
        NgIf,
        DatePipe,
        CommonModule,
        TranslatePipe
    ],
  templateUrl: './order-list-card.component.html',
  styleUrl: './order-list-card.component.scss'
})
export class OrderListCardComponent {
    @Input() order!: OrderSummary;

    constructor(private translate: TranslateService) {
    }
}
